import React from 'react'
import { DateRangePicker } from "react-date-range";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import { useState } from 'react';
import dateUtils from './utilities/DateUtilities';
import { useEffect } from 'react';
import { TABLE_ATTRIBUTE_TYPES } from '../../settings/constants/types';


const DateFilterCalendar = (props) => {
    const [dateRange, setDateRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection'
    })

    const handleDateChange = (ranges) => {
        const { startDate, endDate } = ranges.selection;
        
        var resultedDate;

        if (props.customRangesOperator != null) {
            if (props.customRangesOperator?.columnType === TABLE_ATTRIBUTE_TYPES.DATE) {
                resultedDate = dateUtils.getCalendarFormattedDateByTimeStamp(startDate)
            } else if (props.customRangesOperator?.columnType === TABLE_ATTRIBUTE_TYPES.DATETIME) {
                resultedDate = dateUtils.getFormattedDateTimeForDateTimeColumns(startDate)
            }
        }
        
        setDateRange(ranges.selection);
        props.setSelectedDateOptionIs("");
        props.setDateRangesData(startDate);
        props.handleSelectedDateRange(resultedDate)
    }

    useEffect(() => {
        if (props.customRangesOperator != null) {
            if (props.filterType === "free-range") {
                setDateRange({
                    startDate: new Date(),
                    endDate: new Date(),
                    key: 'selection'
                })
            } else {
                const date = new Date(props.customRangesOperator?.value);
                setDateRange({
                    startDate: date,
                    endDate: date,
                    key: 'selection'
                })
            }
        }
    }, [props.filterType, props.customRangesOperator]);


    return (
        <DateRangePicker
            ranges={[dateRange]}
            onChange={handleDateChange}
            months={1}
            direction="horizontal"
            rangeColors={['#3b82f6']}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
        />
    )
}

export default DateFilterCalendar